import { render, staticRenderFns } from "./salesExWareReviewRecord.vue?vue&type=template&id=0aed0995"
import script from "./salesExWareReviewRecord.vue?vue&type=script&lang=js"
export * from "./salesExWareReviewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports